(function () {
    'use strict';

    function addRequiredDownload(workflowStateService, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/addRequiredDownload.html',
            scope: {
                phaseIndex: '=',
                isActive: '='
            },
            link: function (scope, element, attrs) {
                scope.model = {
                    titleAndPrompt: ''
                }
                scope.allowMultipleFiles = false;
                scope.uploadContext = {
                    isRequiredDownloadCollection: true
                };

                scope.siblingNames = workflowStateService.get().Phases[scope.phaseIndex].RequiredDownloads
                    .filter(function (download) { return !download.IsRemoved; })
                    .map(function (download) { return download.Title; });

                scope.$on('fileUploaded', function(event, args) {
                    if (args.parent.isRequiredDownloadCollection) {
                        scope.stagedUpload = args.blobs[0];
                    }

                    scope.addRequiredDownload();
                });

                scope.removeStagedUpload = function() {
                    scope.stagedUpload = undefined;
                }

                scope.addRequiredDownload = function () {
                    var titleAndPrompt = scope.model.titleAndPrompt;

                    workflowStateService.addRequiredDownloadToPhase(scope.phaseIndex, {
                        Title: titleAndPrompt,
                        Prompt: titleAndPrompt,
                        BlobSummary: scope.stagedUpload
                    });
                    scope.close();
                    $rootScope.$emit('requiredDownloadAdded');
                }

                scope.close = function() {
                    scope.isActive = !scope.isActive;
                    scope.model.titleAndPrompt = '';
                    scope.stagedUpload = undefined;
                }
            }
        };
    }

    addRequiredDownload.$inject = ['workflowStateService', '$rootScope'];

    angular.module('ecap.workflow').directive('addRequiredDownload', addRequiredDownload);
})();

